import request from '../../libs/request';

export default {
  search: (queryParams, siteId) => request(`${siteId}/search/autocomplete`, 'ocean').get({ queryParams }),

  searchProductsInformations: (queryParams, siteId, token) =>
    request(`${siteId}/pdg`, 'ocean').get({ queryParams, token }),

  getSlug: (type, queryParams = null, siteId) => request(`api/v1/${siteId}/slug/url${type}`).get({ queryParams }),
};
